import { OndeTemRow } from '../../../../types/estoque'
import { plural } from '../formato'

export interface LinhaOndeTem {
  localId: number
  localNome: string
  texto: string
  podeSerOrigem: boolean
  ehOrigem: boolean
  ehDestino: boolean
}

export function linhasOndeTem(
  rows: OndeTemRow[], origemId: number | null, destinoId: number | null, ehSerial: boolean,
): LinhaOndeTem[] {
  return rows.map((r) => {
    const localId = Number(r.localId)
    const livre = Number(r.disponivel) || 0
    const texto = ehSerial
      ? plural(livre, 'peça livre', 'peças livres')
      : `${livre} ${livre === 1 ? 'livre' : 'livres'}${r.fisico != null ? ` de ${Number(r.fisico)} no físico` : ''}`
    return {
      localId,
      localNome: r.localNome,
      texto,
      podeSerOrigem: destinoId !== localId,
      ehOrigem: origemId === localId,
      ehDestino: destinoId === localId,
    }
  })
}

export interface EscolhaDeOrigem<L> {
  origemId: number | null
  linhas: L[]
  pendente: { id: number | null } | null
}

export function pedirOrigem<L>(e: EscolhaDeOrigem<L>, id: number | null): EscolhaDeOrigem<L> {
  if (id === e.origemId) return { ...e, pendente: null }
  if (e.linhas.length > 0) return { ...e, pendente: { id } }
  return { origemId: id, linhas: [], pendente: null }
}

export function confirmarOrigem<L>(e: EscolhaDeOrigem<L>): EscolhaDeOrigem<L> {
  if (!e.pendente) return e
  return { origemId: e.pendente.id, linhas: [], pendente: null }
}

export const manterOrigem = <L>(e: EscolhaDeOrigem<L>): EscolhaDeOrigem<L> => ({ ...e, pendente: null })
